// import React from "react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function TokenCoin() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Helmet>
                <title>Token & Coin Development | Secure Web3 Tokens | Blockcryp</title>
                <meta
                    name="description"
                    content="Launch secure, scalable tokens with Blockcryp. From decentralized fundraising to tokenized assets and cross-chain access, we build powerful Web3 token solutions."
                />
                <meta
                    name="keywords"
                    content="token development services, crypto coin development, decentralized fundraising solutions, asset tokenization platform, borderless crypto transactions, Web3 token development, cross-chain token solutions, tokenized access control, custom token creation, token development company for Web3"
                />
            </Helmet>
            {/* ---------- hreo section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 oreder-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            > <span className="text-primary fw-bold"> Token & Coin </span>  Development</motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Redesign digital transactions with our CMMI Level 5 coin and <b> Crypto Token Development Company. </b> We unlock new business opportunities using custom-made blockchain infrastructure and tokenomics that simplify transactions, enhance security, and ensure transparency. Our genius developers stay updated with the market shifts to enhance digital asset management across sectors like finance, healthcare, and gaming, uplifting businesses to adapt quickly and stay relevant in a fast-moving world.</motion.p>
                            <motion.button
                                className="button theme_btn px-lg-4 mt-0 mt-lg-3" type="submit"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Build Your Coin</motion.button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/coin_hero2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/coin_hero.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Tokens Fingertips section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/download2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/download1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-semibold"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Our Crypto Development Company Brings Next-Gen Tokens At Your Fingertips</motion.h3>
                            <motion.p
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Our cryptocurrency development company crafts powerful, next-gen tokens with built-in scalability and utility. Discover how our tailored cryptocurrency development services can elevate your Web3 journey:</motion.p>
                            <div className="d-flex justify-content-lg-start justify-content-center flex-wrap gap-xl-4 gap-lg-1 gap-3">
                                <motion.ul
                                    className="safety-list"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Multi-Chain Minting</li>
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Seamless Token Listing</li>
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Universal Wallet Compatibility</li>
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Token Minting</li>

                                </motion.ul>
                                <motion.ul
                                    className="safety-list"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Strategic Token Pausing</li>
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Token Burning</li>
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Multiple Currency Support</li>
                                    <li className="p-2"><i class="bi bi-check-circle-fill me-2"></i>Multi-Factor Security</li>
                                </motion.ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Token Development Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row g-4 justify-content-center">
                        <div className="col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center mb-3"
                            >
                                <>
                                    {splitTextToSpans(" Capabilities of Token and Coin Development")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Solutions for Businesses", "text-primary")}
                                </>
                            </ScrollFloat>
                        </div>
                        {/* <h2 className="heading_h3 fw-semibold text-center">Capabilities of <span className="text-primary fw-bold"> Token and Coin <br className="d-md-block d-none" /> Development Solutions for Businesses </span></h2> */}
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Decentralized Fundraising</h5>
                                <p className="mb-0">Our team develops secure smart contract protocols for ICOs, IDOs, and STOs, enabling decentralized fundraising, real-time investor tracking, and immutable audit trails with seamless blockchain integration.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Asset Tokenization</h5>
                                <p className="mb-0">Utilizing token standards like ERC-1400 and BEP-20, we tokenize physical and digital assets, embedding ownership, transfer rights, and compliance logic into secure, interoperable assets for enhanced liquidity.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Borderless Transactions</h5>
                                <p className="mb-0">Coins developed by our skilled team enable real-time, gas-optimized peer-to-peer transfers with cryptographic security, eliminating reliance on intermediaries and ensuring global reach.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Brand Identity in Web3</h5>
                                <p className="mb-0">We develop branded tokens with custom smart contract logic, integrated into dApps and wallets, helping businesses establish verifiable Web3 identity, drive loyalty, and engage users in decentralized ecosystems.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Cross-Chain Compatibility</h5>
                                <p className="mb-0">We develop tokens that operate across multiple blockchains using bridging protocols and token standards like ERC-20 and Polkadot. This ensures enhanced user access in a multi-chain crypto environment.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="heading_h5 fw-semibold">Tokenized Access Control</h5>
                                <p className="mb-0">Use tokens as programmable keys to gated features or member-only platforms. We develop access-based tokens that enable monetization strategies and allow businesses to build token-driven communities.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section >
            {/* ---------- Development Services section start ---------- */}
            <section section className="space60" >
                <div className="container">
                    {/* <h2 className="heading_h3 fw-bold text-center mb-5">Explore our Multi-Dimensional Cryptocurrency <br className="d-md-block d-none" /> <span className="text-primary">Development Services</span></h2> */}
                    <div className="row align-items-center g-4">
                        <div className="col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center mb-5"
                            >
                                <>
                                    {splitTextToSpans(" Explore our Multi-Dimensional Cryptocurrency ")} <br className="d-md-block d-none" />
                                    {splitTextToSpans("Development Services", "text-primary fw-bold")}
                                </>
                            </ScrollFloat>
                        </div>
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Crypto Mining Services</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Optimized Mining Hardware :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Enhance your crypto mining efficiency with our cutting-edge hardware solutions. We provide rigs optimized for speed, power efficiency, and stability—ensuring consistent high performance and maximizing your long-term returns.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Strategic Operations Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Achieve peak mining productivity with expert-backed operational strategies. Our team helps reduce downtime, streamline maintenance, and manage energy usage to ensure your mining operations run smoothly and cost-effectively.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Scalable & Sustainable Setups :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Build future-ready mining infrastructure with our scalable setups. Whether expanding capacity or entering new markets, our solutions ensure growth while prioritizing environmental responsibility and long-term sustainability.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/sercoin1.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/sercoin1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section >
            {/* ---------- White Paper Consultation section start ---------- */}
            <section className="space60" >
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/sercoin2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/sercoin2.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >White Paper Consultation</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Professional Blockchain Narratives :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We craft compelling white papers that clearly articulate your blockchain vision, ensuring your idea is presented professionally to attract serious attention from investors and stakeholders.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Clear Technical Communication :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our team simplifies complex blockchain technology into accessible, accurate language, helping readers—from developers to non-tech investors—fully understand your project’s mechanics and potential.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Competitive Project Positioning :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Stand out in the crowded blockchain space with a white paper that not only informs but strategically positions your project as innovative, credible, and investment-worthy in the global market.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </ section>
            {/* ---------- Crypto Listing Services section start ---------- */}
            < section className="space60" >
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Crypto Listing Services</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Streamlined Exchange Listings :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We simplify the entire token listing process by handling documentation, compliance, and technical requirements—getting your crypto listed on top exchanges quickly and efficiently.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Boosted Market Visibility :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our listing services ensure your token gets noticed by the right audience. We help build traction and exposure across top platforms to attract traders, investors, and long-term supporters.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Compliance & Standard Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Navigate complex exchange standards with ease. We ensure your project meets all legal, technical, and community requirements, reducing delays and maximizing listing success.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/sercoin3.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/sercoin3.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </ section>
            {/* ---------- Token Migration Services section start ---------- */}
            <section section className="space60" >
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/sercoin4.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/sercoin4.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Token Migration Services</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Seamless Blockchain Transitions :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Migrate your token across chains smoothly with zero disruptions. Our experts manage the end-to-end process to ensure a flawless shift without compromising performance or accessibility.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Smart Contract Integrity :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We preserve and adapt your smart contracts accurately during migration, maintaining security, logic, and compatibility while avoiding risks or losses in functionality.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >User Trust & Continuity :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Ensure a transparent migration process that retains user confidence. We prioritize communication, security, and data integrity to keep your community engaged and operations uninterrupted.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            {/* ---------- Non-Fungible Tokens section start ---------- */}
            <section section className="space60" >
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Non-Fungible Tokens (NFTs)</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Custom NFT Design & Deployment :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We specialize in creating unique, high-utility NFTs tailored to your brand or vision. From digital art and music to gaming assets and collectibles, our team designs, develops, and deploys NFTs across major platforms like Ethereum, Polygon, and Solana—ensuring maximum reach and impact.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Multi-Platform Integration & Strategy :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Expand your NFT reach with seamless integration across leading marketplaces such as OpenSea, Rarible, and Magic Eden. We craft smart strategies that align with your business goals, whether you’re launching a collection, enabling in-game assets, or building loyalty programs through NFTs.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Scalable NFT Ecosystems with Real Value :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Go beyond simple ownership with NFTs that offer functionality—like staking, royalties, or unlockable content. We help build scalable ecosystems that create long-term value for both creators and collectors, making your NFT offering more than just a digital asset—it becomes a community experience.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/sercoin5.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/sercoin5.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section >
            {/* ---------- Security Token Development section start ---------- */}
            <section className="space60" >
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/tokencoin/sercoin6.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/tokencoin/sercoin6.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Security Token Development</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Fully Compliant Tokenized Assets :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We develop security tokens that meet global regulatory standards, enabling tokenized shares, bonds, and real-world assets to be traded legally. From KYC/AML integration to SEC or EU compliance, our solutions are built for secure and lawful institutional-grade adoption.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >End-to-End STO Launch Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    From concept to deployment, we offer complete Security Token Offering (STO) support, including whitepaper drafting, smart contract development, legal framework integration, and investor dashboard setup—ensuring your offering is investor-ready and audit-friendly.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Institutional-Grade Security & Infrastructure :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our security token solutions are built with advanced blockchain protocols, incorporating features like dividend distribution, voting rights, and ownership tracking. We ensure high-level security, transparency, and scalability for attracting institutional investors globally.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Token Development Services section start ---------- */}
            <section className="space60 services" >
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 p-0 mb-4">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Explore Our Comprehensive Crypto Token")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Development Services", "text-primary fw-bold")}
                                </>
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Explore Our Comprehensive Crypto <span> Token Development Services </span></h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Discover boundless possibilities with our cryptocurrency development services, spanning across various <br className="d-md-block d-none" /> blockchains and asset types.</motion.p>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin1-dark.svg"
                                            : "assets/images/tokencoin/tokencoin1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Crypto Token Consulting & Advisory</h5>
                                <p>Our experienced crypto coin development consultants deliver strategic insights and expert guidance, ensuring you navigate your crypto initiatives precisely and confidently.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin2-dark.svg"
                                            : "assets/images/tokencoin/tokencoin2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Designing Meme Coins</h5>
                                <p>We excel in crafting innovative meme coins that capture market interest and enhance the unique value proposition of your digital asset ecosystem through expert cryptocurrency development services.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin3-dark.svg"
                                            : "assets/images/tokencoin/tokencoin3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">AI-Based Tokens</h5>
                                <p>We develop advanced AI-based crypto development solutions that merge AI with blockchain technology, enhancing intelligent decision-making and creating smart tokenized systems.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin4-dark.svg"
                                            : "assets/images/tokencoin/tokencoin4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Stablecoin Creation</h5>
                                <p>As a premium crypto coin development company, we create exclusive stablecoins, such as cryptocurrency-backed, fiat-backed, commodity-backed, and gold-backed stablecoins, ensuring stability and reliability.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin5-dark.svg"
                                            : "assets/images/tokencoin/tokencoin5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Equity/Asset-Backed Tokens</h5>
                                <p>Our crypto development team specializes in the creation of security tokens, utility tokens, and equity tokens, facilitating efficient capital-raising and asset-backed initiatives for your business.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin6-dark.svg"
                                            : "assets/images/tokencoin/tokencoin6-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Telegram Bot Tokens</h5>
                                <p>We offer advanced crypto development services to integrate secure trading functionalities with custom Telegram bot tokens, enhancing operational efficiency and user engagement.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin7-dark.svg"
                                            : "assets/images/tokencoin/tokencoin7-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Non-Fungible Tokens</h5>
                                <p>Enlist our crypto token development services to develop distinctive NFTs, enabling the tokenization of a broad range of assets from art and music to digital ownership, with precision and innovation.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin8-dark.svg"
                                            : "assets/images/tokencoin/tokencoin8-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">DeFi Tokens</h5>
                                <p>Our high-caliber DeFi crypto token development services empower decentralized finance operations, including streamlined processes for borrowing, lending, and investment management.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin9-dark.svg"
                                            : "assets/images/tokencoin/tokencoin9-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Metaverse Tokens</h5>
                                <p>Collaborate with our skilled cryptocurrency development experts to design, develop, and deploy metaverse tokens across major networks, aligning with the latest virtual environment standards.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin10-dark.svg"
                                            : "assets/images/tokencoin/tokencoin10-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Altcoin Creation Service</h5>
                                <p>We provide advanced crypto coin development services, crafting robust and secure altcoins that act as reliable mediums of exchange within your digital financial landscape.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin11-dark.svg"
                                            : "assets/images/tokencoin/tokencoin11-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Token Migration Services</h5>
                                <p>Our cryptocurrency development expertise extends to seamless token migration across blockchain platforms, ensuring interoperability and continuity for your tokenized assets.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/tokencoin/tokencoin12-dark.svg"
                                            : "assets/images/tokencoin/tokencoin12-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Custom Token Development</h5>
                                <p>We deliver bespoke crypto token development services designed to meet your strategic and technological requirements as per your project requirements.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- why choose defi section start ---------- */}
            <section className="space60 why_choose_defi" >
                <div className="container">
                    <div className="row justify-content-between g-4">
                        <div className="col-xl-5">
                            <motion.h2
                                className="heading_h3 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Mastering the Spectrum of Web3 Coin Development</motion.h2>
                            <motion.p
                                className=""
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >At the forefront of blockchain innovation, we are a cryptocurrency development company committed to delivering cutting-edge coin development services that power the Web3 revolution. With a focus on security, scalability, and advanced functionality, we create customized Web3 tokens tailored to your unique business requirements. Our team of experts excels in tokenomics, smart contract architecture, and seamless integration with decentralized networks, ensuring optimal performance across various blockchain platforms. Through our comprehensive cryptocurrency development services, we drive innovation and secure growth, positioning your project at the leading edge of the decentralized economy.</motion.p>
                        </div>
                        <div className="col-xl-6">
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <motion.div
                                        initial={{ opacity: 0, x: 50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <h5 className="text_22 fw-semibold"><i class="fa-solid fa-circle-check pe-2"></i>Security Tokens</h5>
                                        <p className="fw-normal text-muted">We specialize in the security crypto token development that represents real-world assets, ensuring full regulatory compliance and unlocking liquidity for traditionally illiquid investments within the crypto development landscape.</p>
                                    </motion.div>
                                </div>
                                <div className="col-md-6">
                                    <motion.div
                                        initial={{ opacity: 0, x: 50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <h5 className="text_22 fw-semibold"><i class="fa-solid fa-circle-check pe-2"></i>Utility Tokens</h5>
                                        <p className="fw-normal text-muted">Our crypto token development services create utility tokens that power essential functionalities across decentralized platforms, providing seamless access to blockchain-based services and driving the cryptocurrency development ecosystem.</p>
                                    </motion.div>
                                </div>
                                <div className="col-md-6">
                                    <motion.div
                                        initial={{ opacity: 0, x: 50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <h5 className="text_22 fw-semibold"><i class="fa-solid fa-circle-check pe-2"></i>Governance Tokens</h5>
                                        <p className="fw-normal text-muted">Through our expertise in cryptocurrency development, we develop governance tokens that grant holders voting rights, enabling decentralized decision-making and shaping the future direction of blockchain protocols.</p>
                                    </motion.div>
                                </div>
                                <div className="col-md-6">
                                    <motion.div
                                        initial={{ opacity: 0, x: 50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 1, delay: 0.5 }}
                                        viewport={{ once: false, amount: 0.5 }}
                                    >
                                        <h5 className="text_22 fw-semibold"><i class="fa-solid fa-circle-check pe-2"></i>Transactional Tokens</h5>
                                        <p className="fw-normal text-muted">We master the creation of transactional tokens, functioning as digital currencies that facilitate the smooth transfer of value within blockchain networks and support the growth of De-Fi systems through innovative cryptocurrency development solutions.</p>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- faq section start ---------- */}
            <section section className="space60">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1. Can I convert my token into a standalone coin later?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Yes, you can migrate a token into a standalone coin by creating a custom blockchain and facilitating a swap. This transition requires careful planning, wallet development, network launch, and user communication to ensure all token holders receive the new coin seamlessly.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2. How do I create my own cryptocurrency coin or token?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Start by defining your project’s goals and choosing the right blockchain. Then, develop smart contracts, design tokenomics, conduct audits, and deploy. Coin creation involves building a blockchain, while token development uses existing chains like Ethereum, BNB Chain, or Polygon.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3. Can tokens be used for fundraising like ICOs or IDOs?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Yes, tokens are essential in fundraising through ICOs and IDOs. They provide early backers access to future project benefits. Launchpads, smart contracts, and liquidity planning play critical roles in ensuring a successful, transparent, and compliant token-based fundraising campaign.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4. How much does it cost to develop a crypto coin or token?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The development cost varies from $5,000 to $100,000 depending on blockchain type, features, complexity, and security audits. Custom coins with independent blockchains cost more, while tokens on platforms like Ethereum or BSC are faster and more affordable to deploy securely. Contact us for more details.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5. How do tokenomics affect the success of a crypto project?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Tokenomics shapes a project’s sustainability by defining supply, utility, and incentive mechanisms. A strong model encourages user participation, market stability, and long-term value. Poorly designed tokenomics can lead to low adoption, rapid dumping, and a lack of investor and user trust.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
